export default __webpack_public_path__ + "static/media/sign-in-dark.f178c006.svg";